import { format } from 'date-fns';

const formatDate = (date: Date, hideDateTime = false) => format(date, hideDateTime ? 'dd/LL/yyyy' : 'dd/LL/yyyy HH:mm');

export default formatDate;
